import * as yup from 'yup'

{
  /* ひとまず英語にした sakao  */
}
export const loginIdSchema = yup
  .string()
  .matches(/^[a-zA-Z0-9]{10,}$/, '10_id_alphanumeric_warning')
  .min(10, '10_id_alphanumeric_warning')
  .max(20, '20_id_alphanumeric_warning')
  .required('id_warning')

export const strictPasswordSchema = yup
  .string()
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{10,}$/, '10_passward_alphanumeric_warning_re')
  .min(10, '10_passward_alphanumeric_warning_re')
  .max(20, '20_passward_alphanumeric_warning_re')
  .required('passward_warning')

export const softPasswordSchema = yup
  .string()
  .matches(/^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{10,}$/, '10_passward_alphanumeric_warning_re2')
  .min(10, '10_passward_alphanumeric_warning_re2')
  .max(20, '20_passward_alphanumeric_warning_re2')
  .required('passward_warning')
